
export const APP_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || '',
  LOGIN_PAGE: {
    TITRE: "FORMATION EN LIGNE",
    SOUS_TITRE: "Ivoire Soft services",
    DESCRIPTION: "Accédez à votre portail  sécurisé "
  },
  API_ENDPOINTS: {
    AUTHORIZE: "/oauth2/authorize",
    TOKEN: "/oauth2/token"
  }
};


